module.exports = __webpack_public_path__ + "nz.svg?0d0a6af071d3b3ded43cbce610d66951";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/nz.svg
// module id = 1153
// module chunks = 27